import { SaSet } from './types';

const sm: SaSet = {
  categories: [
    'Platforms kennen',
    'Bewust gebruik',
    'Kritisch & veilig',
    'Verbinden & delen',
    'Reflectie & identiteit',
  ],
  items: [
    // Platforms kennen
    {
      category: 'Platforms kennen',
      text: 'Ik weet welke socialmediaplatforms er zijn en waar elk van bedoeld is.',
      quick: true,
    },
    {
      category: 'Platforms kennen',
      text: 'Ik begrijp waarom het ene platform vooral bij jongeren leeft en het andere bij een oudere of zakelijke groep.',
    },
    {
      category: 'Platforms kennen',
      text: 'Ik weet dat mensen ook in games en op gamingplatforms met elkaar contact hebben.',
      quick: true,
    },
    {
      category: 'Platforms kennen',
      text: 'Ik snap het verschil tussen een open platform en een besloten berichtenapp.',
    },
    {
      category: 'Platforms kennen',
      text: 'Ik weet dat social media een voorgeschiedenis heeft, met dingen als fora, MSN en Hyves.',
    },
    {
      category: 'Platforms kennen',
      text: 'Ik volg een beetje hoe de platforms veranderen en welke opkomen of juist verdwijnen.',
    },

    // Bewust gebruik
    {
      category: 'Bewust gebruik',
      text: 'Ik kies bewust welke platforms ik gebruik en waarvoor.',
      quick: true,
    },
    {
      category: 'Bewust gebruik',
      text: 'Ik merk het als een app me langer vasthoudt dan ik eigenlijk van plan was.',
      quick: true,
    },
    {
      category: 'Bewust gebruik',
      text: 'Ik heb mijn meldingen zo ingesteld dat ze me niet de hele dag onderbreken.',
    },
    {
      category: 'Bewust gebruik',
      text: 'Ik kan mijn schermtijd op social media bewust naar beneden brengen als ik dat wil.',
    },
    {
      category: 'Bewust gebruik',
      text: 'Ik leg mijn telefoon geregeld weg op momenten die ik vrij wil houden, zoals aan tafel of voor het slapen.',
    },
    {
      category: 'Bewust gebruik',
      text: 'Ik herken bij mezelf wanneer het scrollen vooral uit gewoonte of onrust gebeurt.',
    },

    // Kritisch & veilig
    {
      category: 'Kritisch & veilig',
      text: 'Ik begrijp in grote lijnen hoe een algoritme bepaalt wat ik in mijn feed zie.',
      quick: true,
    },
    {
      category: 'Kritisch & veilig',
      text: 'Ik weet dat wat ik zie een selectie is, en niet een eerlijk beeld van de hele werkelijkheid.',
    },
    {
      category: 'Kritisch & veilig',
      text: 'Ik check bij een opvallend of boos makend bericht eerst of het wel klopt.',
      quick: true,
    },
    {
      category: 'Kritisch & veilig',
      text: 'Ik let op mijn privacy-instellingen en weet ongeveer wie mijn berichten kan zien.',
    },
    {
      category: 'Kritisch & veilig',
      text: 'Ik herken reclame en betaalde of gesponsorde berichten tussen gewone inhoud.',
    },
    {
      category: 'Kritisch & veilig',
      text: 'Ik weet wat ik kan doen bij vervelend gedrag online, zoals blokkeren, melden of het gesprek stoppen.',
    },

    // Verbinden & delen
    {
      category: 'Verbinden & delen',
      text: 'Ik denk na over wat ik plaats en wie het kan zien voordat ik op verzenden druk.',
      quick: true,
    },
    {
      category: 'Verbinden & delen',
      text: 'Ik gebruik social media ook om iets op te bouwen, te leren of mensen te bereiken die ik anders niet zou spreken.',
    },
    {
      category: 'Verbinden & delen',
      text: 'Ik houd er rekening mee dat ik ook iets over anderen deel als ik foto’s of verhalen plaats.',
    },
    {
      category: 'Verbinden & delen',
      text: 'Ik reageer op een manier waar ik later nog achter kan staan, ook als ik het ergens niet mee eens ben.',
      quick: true,
    },
    {
      category: 'Verbinden & delen',
      text: 'Ik weet hoe ik een platform zakelijk of voor mijn werk kan inzetten als dat nuttig is.',
    },
    {
      category: 'Verbinden & delen',
      text: 'Ik snap dat wat ik online plaats lang kan blijven bestaan en lastig helemaal weg te halen is.',
    },

    // Reflectie & identiteit
    {
      category: 'Reflectie & identiteit',
      text: 'Ik denk na over wat mijn gebruik zegt over mezelf en wat ik belangrijk vind.',
      quick: true,
    },
    {
      category: 'Reflectie & identiteit',
      text: 'Ik besef dat een feed vooral hoogtepunten laat zien en niet het hele verhaal van iemand.',
      quick: true,
    },
    {
      category: 'Reflectie & identiteit',
      text: 'Ik merk het als ik mezelf begin te vergelijken met wat anderen online laten zien.',
    },
    {
      category: 'Reflectie & identiteit',
      text: 'Ik kan een rustig gesprek voeren over social media, bijvoorbeeld met kinderen, familie of collega’s.',
    },
    {
      category: 'Reflectie & identiteit',
      text: 'Ik kan me voorstellen hoe het zou zijn om een tijd zonder een bepaald platform te leven.',
    },
    {
      category: 'Reflectie & identiteit',
      text: 'Ik sta er weleens bij stil of de tijd die ik aan een platform geef me echt iets oplevert.',
    },
  ],
};

export default sm;
